exports = module.exports = require("../../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.tofu-icon-component {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n}\n.tofu-icon-component .icon-font {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n}\n.tofu-icon-component .icon-image {\n    position: absolute;\n    top: 50%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-7e5fa654!./~/_sass-loader@6.0.6@sass-loader/lib/loader.js!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/tofu-icon/src/icon.vue
// module id = 467
// module chunks = 0